<template>
    <ProductFilterChips />
    <div class="flex flex-col items-center justify-center min-h-96 mt-20">
        <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_ORDERS_PATH}NoDataHome.svg`" />
        <div class="flex flex-col items-center justify-center text-center max-w-md mx-auto">
            <h2 class="text-base font-semibold text-[#464646] font-inter mb-1">
                {{ t('globalCatalog.noResultsTitle') }} <span class="w-[500px] break-words">'{{ committedSearchTerm  }}'</span>
            </h2>

            <p class="text-base mb-2 text-[#464646]">
                {{ t('globalCatalog.noResultsMessageLine1') }} <br />
                {{ t('globalCatalog.noResultsMessageLine2') }}
                <a href="#" class="underline text-gray-800" @click="clearAllFilters()"> {{ t('globalCatalog.clearFiltersText') }}</a>
                {{ t('globalCatalog.orExecuteSearchText') }}
            </p>

            <BaseButton size="custom" @click="clearSearch()"
                variant="secondary"
                class="text-[16px] !border !border-[#B9B9B9] !rounded-[4px] font-normal px-2 py-1">
                {{ t('globalCatalog.clearSearchButtonText') }}
            </BaseButton>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_ORDERS_PATH } from "@/config/constants.js";
import { useI18n } from 'vue-i18n';
import { getLanguage } from '@/utilities/cookies';
import { useGlobalCatalogStore } from '@/stores/globalCatalogStore'
import ProductFilterChips from '@/components/GlobalCatalog/Products/ProductFilterChips.vue';
import BaseButton from '@/components/atoms/buttons/BaseButton.vue';

const globalCatalogStore = useGlobalCatalogStore()

// Show the term that was actually searched. Read it from the store (single source of truth)
// rather than localStorage, which CatalogSearchBar clears right after kicking off the search -
// before this component mounts - which made the message render an empty term.
const committedSearchTerm = computed(() => globalCatalogStore.productSearchTerm || '')

const { t, locale } = useI18n();
locale.value = getLanguage();


function clearSearch() {
    globalCatalogStore.clearProductSearch();
}

function clearAllFilters() {
    globalCatalogStore.clearAllFilters();
}
</script>